import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function TimelineIcon(props: IconProps) {
    return <Icon {...props} iconKey={"timeline"}/>
}
